
import Vue from 'vue'
import { MessageBox } from 'element-ui'
function handleConfirm(message) {
  var obj = Object.assign({ msg: '', type: 'success', showConfirm: true, tips: '' }, message)
  var str = `<div class="wrap">
    <div class="message">
      ${obj.msg}
      <div class="tips">${obj.tips}</div>
    </div>
  </div>`
  return new Promise(function(resolve, reject) {
    MessageBox.confirm(str, {
      dangerouslyUseHTMLString: true,
      showConfirmButton: obj.showConfirm,
      showCancelButton: true,
      cancelButtonText: obj.showConfirm ? '取消' : '知道了',
      confirmButtonText: '确定',
      type: obj.type || '',
      showClose: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      customClass: 'message-box-wrap'
    }).then(() => {
      resolve()
    }).catch(() => {
      reject()
    })
  })
}
function registryConfirm() {
  Vue.prototype.$toConfirm = handleConfirm
}
export default registryConfirm

